'use server-only';

import { c as _c } from "react/compiler-runtime";
import { Popover, PopoverButton, PopoverPanel, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/solid';
import { Fragment } from 'react';
import { Link } from '@/frontend/design-system/actions/Link';
import { mentoringLinks } from '../_components/NavigationItems';
export function MentoringSection() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Popover className="relative">{_temp2}</Popover>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp2(t0) {
  const {
    open
  } = t0;
  return <><PopoverButton className="inline-flex items-center gap-x-1 font-medium text-slate-900 text-sm hover:text-algosecondary hover:underline focus:outline-none"><span>Mentoring</span><ChevronDownIcon className={`h-3 w-3 transition-transform duration-200 ${open ? "rotate-180 transform" : ""}`} aria-hidden="true" /></PopoverButton><Transition as={Fragment} enter="transition ease-out duration-200" enterFrom="opacity-0 translate-y-1" enterTo="opacity-100 translate-y-0" leave="transition ease-in duration-150" leaveFrom="opacity-100 translate-y-0" leaveTo="opacity-0 translate-y-1"><PopoverPanel className="absolute top-full -left-8 z-10 mt-3 w-56 rounded-xl bg-white p-2 shadow-lg ring-1 ring-slate-900/5">{_temp}</PopoverPanel></Transition></>;
}
function _temp(t0) {
  const {
    close
  } = t0;
  return <>{mentoringLinks.map(item => <Link key={item.name} href={item.href} onClick={() => close()} className="block rounded-lg px-3 py-2 font-semibold text-slate-900 text-sm leading-6 hover:bg-gray-50">{item.name}</Link>)}</>;
}